import React from 'react';
import {
    Grid, InputAdornment,
    TextField,
} from '@material-ui/core';
import {useTranslation} from "react-i18next";



const ConnectorFormCountOfPackages = ({ value, setCountOfPackages, submitted, ...rest }) => {
    const {t} = useTranslation('connector');

    return (
        <Grid item xs={12}>
            <TextField
                fullWidth
                id="connector-count-of-packages"
                label={t('label.connector_count_of_packages')}
                variant="outlined"
                value={ value }
                onChange={(event) => setCountOfPackages(event.target.value)}
                disabled={submitted}
                required
            />
        </Grid>
    )
}

export default ConnectorFormCountOfPackages;